var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center m-auto align-items-center",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"col-12 col-sm-12 text-center"},[_c('h1',[_vm._v("Halaman Tidak ditemukan")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Kembali Ke Halaman Utama")])])])
}]

export { render, staticRenderFns }